export default {
  Actions: {
    FETCH_REVIEW_CYCLES_SUCCESS: 'review_cycles/FETCH_REVIEW_CYCLES_SUCCESS',
    FETCH_REVIEW_CYCLE_SUCCESS: 'review_cycles/FETCH_REVIEW_CYCLE_SUCCESS',
    CREATE_REVIEW_CYCLE_SUCCESS: 'review_cycles/CREATE_REVIEW_CYCLE_SUCCESS',
    UPDATE_REVIEW_CYCLE_SUCCESS: 'review_cycles/UPDATE_REVIEW_CYCLE_SUCCESS',
    DELETE_REVIEW_CYCLE_SUCCESS: 'review_cycles/DELETE_REVIEW_CYCLE_SUCCESS',
    LAUNCH_REVIEW_CYCLE_SUCCESS: 'review_cycles/LAUNCH_REVIEW_CYCLE_SUCCESS',
    LAUNCH_SCHEDULED_REVIEW_CYCLE_SUCCESS: 'review_cycles/LAUNCH_SCHEDULED_REVIEW_CYCLE_SUCCESS',
    UNSCHEDULE_REVIEW_CYCLE_SUCCESS: 'review_cycles/UNSCHEDULE_REVIEW_CYCLE_SUCCESS',
    CANCEL_REVIEW_CYCLE_SUCCESS: 'review_cycles/CANCEL_REVIEW_CYCLE_SUCCESS',
    CLOSE_REVIEW_CYCLE_SUCCESS: 'review_cycles/CLOSE_REVIEW_CYCLE_SUCCESS',
    DELETE_REVIEW_SUCCESS: 'review_cycles/DELETE_REVIEW_SUCCESS',
    CREATE_REVIEWS_ON_REVIEW_CYCLE_SUCCESS: 'review_cycles/CREATE_REVIEWS_ON_REVIEW_CYCLE_SUCCESS',
  },
  State: {
    REVIEWS_CYCLES_BY_SLUG: 'REVIEWS_CYCLES_BY_SLUG',
  },
};
